var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 85,
    viewBox: "0 0 49 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_439_945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.683594 42.5573C0.683594 32.2428 0.683594 21.9283 0.683594 11.6139C0.683594 10.1731 0.683594 8.71292 0.828641 7.27212C1.0994 4.62259 2.19208 2.2825 4.86095 1.18014C7.68454 0.0100912 9.85058 1.42188 11.7652 3.32684C19.8492 11.3979 27.9363 19.4819 36.0268 27.5787C39.4499 30.9922 42.844 34.4346 46.2671 37.8384C49.4904 41.0617 49.5097 44.2849 46.3251 47.5082C34.7213 59.112 23.1176 70.7158 11.5138 82.3195C9.74421 84.0891 7.70388 85.3849 5.02534 84.3115C1.65057 82.9481 0.780292 80.0471 0.760952 76.8464C0.683594 65.4167 0.731943 53.987 0.731943 42.5573H0.683594Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_439_945"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.0396,
    height: 83.9533,
    fill: "white",
    transform: "translate(0.683594 0.7547)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play_icon.3b5f64ce21fe65d11d2137dda6ffcbdc.svg";
export { ForwardRef as ReactComponent };